import React from 'react'
import withoutAuthentication from '../components/withoutAuthentication'
import PasswordResetPage from '../components/Password/Reset/Page'

const ScreensPasswordReset = () => <PasswordResetPage />

export default withoutAuthentication()(ScreensPasswordReset)
